import { SelectOption } from '@/features/editMode/types/selectOption';
import { z } from 'zod';
import {
  RelationshipNormalizedSelectOptions,
  RelationshipOptionsResponse,
} from '@/hooks/api/useFetchRelationshipOptions';

class FormService {
  public static mandatoryLabel(labelText: string, isMandatory: boolean) {
    return isMandatory ? `${labelText}*` : labelText;
  }

  public static normalizeRelationshipOptions(
    inputOptions: RelationshipOptionsResponse[],
  ): RelationshipNormalizedSelectOptions[] {
    return inputOptions.map((option) => {
      return { label: option.name, value: option.id.toString(), type: option?.type };
    });
  }

  public static optionId(isNullable: boolean = true, errorMessage?: string) {
    return z.preprocess(
      (v) => (!v ? null : +(v as string)),
      isNullable
        ? z.number(errorMessage ? { message: errorMessage } : {}).nullable()
        : z.number(errorMessage ? { message: errorMessage } : {}),
    );
  }

  public static boolean(errorMessage?: string) {
    return z.preprocess(
      (v) => {
        if (v === 'true' || v === true) return true;
        if (v === 'false' || v === false) return false;
        return null;
      },
      z.boolean(errorMessage ? { message: errorMessage } : {}),
    );
  }

  public static prependEmptyOption(
    options?: SelectOption[] | null,
    emptyOption: SelectOption = { value: '', label: '-' },
  ): SelectOption[] {
    return options?.length ? [emptyOption, ...options] : (options ?? []);
  }

  public static checkIsInputAutofilled(inputElement?: HTMLInputElement) {
    if (!inputElement) return false;

    const computedStyle = window.getComputedStyle(inputElement);
    return computedStyle.webkitAppearance === 'menulist-button';
  }

  public static removeAutofillFromTheInput(inputElement?: HTMLInputElement, callback: () => void = () => {}) {
    if (!inputElement) return false;

    const originalValue = inputElement.value;
    inputElement.value = '';
    inputElement.dispatchEvent(new Event('input', { bubbles: true }));

    setTimeout(() => {
      inputElement.value = originalValue;
      inputElement.dispatchEvent(new Event('input', { bubbles: true }));
      callback();
    }, 0);
  }

  public static handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
}

export default FormService;
